import script from "./FooterDevelopers.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterDevelopers.vue?vue&type=script&setup=true&lang=js"

import "./FooterDevelopers.vue?vue&type=style&index=0&id=522d5006&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522d5006"]])

export default __exports__